import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        employees: '=',
        companyStatistics: '=',
        sites: '=',
        classifiers: '='
    },
    template
})

export default class {
    constructor ($scope, $sce, $translate, lodash, DATATABLES, ListFactory, CourseResource, UserResource,
                 ClassifierResource, PrivilegeService, SiteService, TokenService, UserService,
                 ROLE_PRIVILEGE_ENUM, ROLE_CODE_ENUM, USER_STATUS_ENUM, $state, ReportService) {
        this.$scope = $scope;
        this.$sce = $sce;
        this.$translate = $translate;
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.CourseResource = CourseResource;
        this.UserResource = UserResource;
        this.ClassifierResource = ClassifierResource;
        this.PrivilegeService = PrivilegeService;
        this.ReportService = ReportService;
        this.SiteService = SiteService;
        this.TokenService = TokenService;
        this.UserService = UserService;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.$state = $state;
    }

    $onInit () {
        if (this.PrivilegeService.canViewPlanning()) {
            this.initTrainingNeeds();
        }

        this.successRateLabel = this.$translate.instant(
            'home.{passedCount} learners completed; {failedCount} learners not completed',
            {
                passedCount: this.companyStatistics.coursesPassedTotalCount,
                failedCount: this.companyStatistics.coursesFailedTotalCount
            }
        );

        this.statPlanningSiteIds = this.SiteService.getSitesByPrivileges(
            [this.ROLE_PRIVILEGE_ENUM.KEYS.PLANNING_VIEW, this.ROLE_PRIVILEGE_ENUM.KEYS.PLANNING_MANAGE]
        ).map((site) => site.id);
        this.statCourseResultsSiteIds = this.SiteService.getSitesByPrivileges(
            [this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_COURSES_RESULTS_VIEW]
        ).map((site) => site.id);

        this.initToolTips();

        this.quickActionButtons = [
            {
                icon: 'assets/css/shortcut01.svg',
                label: this.$translate.instant('dashboard.quickActionButton.Add course'),
                url: this.$state.href('authorized.courses.courses.add.general'),
                isEnabled: this.PrivilegeService.canManageCourses()
            },
            {
                icon: 'assets/css/shortcut02.svg',
                label: this.$translate.instant('dashboard.quickActionButton.Manage courses'),
                url: this.$state.href('authorized.courses.courses'),
                isEnabled: this.PrivilegeService.canViewCourses()
            },
            {
                icon: 'assets/css/shortcut03.svg',
                label: this.$translate.instant('dashboard.quickActionButton.Manage users'),
                url: this.$state.href('authorized.user.employee.list'),
                isEnabled: this.PrivilegeService.canViewUsers()
            },
            {
                icon: 'assets/css/shortcut04.svg',
                label: this.$translate.instant('dashboard.quickActionButton.View reports'),
                url: this.$state.href(this.ReportService.getFirstReportState()),
                isEnabled: this.PrivilegeService.canViewCoursesAndUsersReports()
            }
        ];
    }

    initToolTips () {
        this.sitesLabel = this.$translate.instant('home.Data about sites');
        if (this.TokenService.getSiteCount() === this.SiteService.sites.length) {
            this.sitesValue1 = this.$translate.instant('home.All company sites');
            this.sitesValue2 = this.$translate.instant('home.All company sites');
        }
        else {
            // two different privilege groups are used for 4 statistic blocks
            // So compose two separate strings for 4 tooltips
            this.sitesValue1 = this.SiteService.getSitesByPrivileges(
                [this.ROLE_PRIVILEGE_ENUM.KEYS.PLANNING_VIEW, this.ROLE_PRIVILEGE_ENUM.KEYS.PLANNING_MANAGE]
            ).map((site) => site.name).join(', ');
            this.sitesValue2 = this.SiteService.getSitesByPrivileges(
                [this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_COURSES_RESULTS_VIEW]
            ).map((site) => site.name).join(', ');
        }

        this.$scope.tooltipContent1 = this.$sce.trustAsHtml(`${this.sitesLabel}: ${this.sitesValue1}`);
        this.$scope.tooltipContent2 = this.$sce.trustAsHtml(`${this.sitesLabel}: ${this.sitesValue2}`);
        this.$scope.tooltipContent3 = this.$sce.trustAsHtml(
            `${this.successRateLabel}<br>${this.sitesLabel}: ${this.sitesValue2}`
        );
        this.$scope.tooltipContent4 = this.$sce.trustAsHtml(`${this.sitesLabel}: ${this.sitesValue1}`);
    }

    initTrainingNeeds () {
        this.trainingNeedsFilter = {};
        this.trainingNeedsDefaultFilter = { expand: 'courseActiveI18n,planningGroups', pageSize: 10 };
        if (!this.SiteService.hasAccessToAllSites(this.sites)) {
            this.trainingNeedsDefaultFilter.siteId = this.SiteService.getActiveSiteId();
        }
        this.trainingNeedsList = this.ListFactory.createWithPagination(this.CourseResource.trainingNeeds.bind(this.CourseResource));
        this.trainingNeedsList.fetch(this.trainingNeedsDefaultFilter);
    }

    initClassifiers () {
        this.classifiers = [];
        this.ClassifierResource.query().$promise.then(classifiers => {
            this.classifiers = classifiers;
        });
    }

    toggleCoursesFilter () {
        this.showCoursesFilter = !this.showCoursesFilter;
    }

    toggleEmployeeFilter () {
        this.showEmployeeFilter = !this.showEmployeeFilter;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home/index.js